<template>
<div class="chapter">
<div class="inner_page">
<p class="center"><a id="page_cov"></a><img alt="Image" src="images/MyCoverImage.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 00_cover.vue?49e87b15